import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpService} from '../../../../../../core';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';


@Component({
  selector: 'app-delete-lot-dialog',
  templateUrl: './deleteLotDialog.component.html',
  styleUrls: ['./deleteLotDialog.component.scss']
})

export class DeleteLotDialogComponent implements OnInit {
  constructor(
    private httpService: HttpService,
    private toastrService: ToastrService,
    private router: Router,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  delete() {
    this.httpService.deleteLot(this.data.lotId).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.toastrService.success('The lot has been deleted.');
        this.dialogRef.close({result: 1});
      } else {
        this.toastrService.error('Failed to delete this lot.');
        this.dialogRef.close({result: 0});
      }
    });
  }
}
